import routes from '../routes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import Account from '../../UserSettings/Account/Account';
import UploadCases from '../../UserSettings/UploadCases/UploadCases';

const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.USERSETTINGS],
    component: Account,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths: [routes.UPLOADCASES],
    component: UploadCases,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  }
]);

export const settingsModule = (): IRouteModule => ({
  name: RoutesModules.SETTINGS,
  routes: moduleRoutes(),
  navbar: routes.USERSETTINGS,
  settingsNavbar: true,
  sidebar: [
    {
      navTitle: 'Account',
      route: routes.USERSETTINGS,
      isMainPath: true
    },
    {
      navTitle: 'Upload Cases',
      route: routes.UPLOADCASES,
      hideOnMobile: true
    },
    {
      navTitle: 'Terms of use',
      route: routes.TERMSOFUSE
    }
  ]
});
